export const ease = {
  outSmooth: [0, 0.55, 0.45, 1],
  outSnap: [0.22, 1, 0.36, 1],
  inSmooth: [0.55, 0, 1, 0.45],
  inSnap: [0.64, 0, 0.78, 0],
  inOutSmooth: [0.65, 0, 0.35, 1],
  inOutSnap: [0.83, 0, 0.17, 1],
};
